import { Injectable } from '@angular/core';
import { ServiceBase } from './servicebase.service';
import { Observable, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductsListService extends ServiceBase {  
  public searchIRs(query: string): Observable<ServerModels.CIPSelectionValues[]> {
    return this.http.get<ServerModels.CIPSelectionValues>(`${this.apiRoot}/api/NESSProductsLists/SearchIRs?query=${query}`, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('searchIRs', 'defaultMsg', null, null))); 
  }
}
